module.exports = __webpack_public_path__ + "static/img/invete7.43630b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/invete7.png
// module id = WOOY
// module chunks = 87